import { Flex } from 'antd';
import type React from 'react';
import type { LabResultOrder } from '../../../../generated/openapi/befunde-api';
import { formatDateString, formatTimeString } from '../../../../utils/datetime.ts';
import { useLabResultOrderCellStyles } from './useLabResultOrderCellStyles.ts';

export const LabResultOrderCell: React.FC<{ order: LabResultOrder }> = ({ order }) => {
  const styles = useLabResultOrderCellStyles();
  return (
    <Flex vertical>
      <Flex gap="small" align="end">
        <div className={styles.date}>{formatDateString(order.timestamp)}</div>
        <div className={styles.time}>{formatTimeString(order.timestamp)}</div>
      </Flex>
      <div className={styles.orderNumber}>{order.orderNumber}</div>
    </Flex>
  );
};
